import { Outlet } from 'react-router-dom';

function Notificaciones() {
  return <Outlet />;
}

export default Notificaciones;
